import { TimelineProvider } from "@/machines/context/timeline-context.tsx";
import MachinesDetailContent  from "@/machines/pages/machines-detail/machines-detail-content.tsx";
import { useParams } from "react-router-dom";
import { useFilterStore } from "@/shared/stores/useFilterStore.ts";
import { useGetEvents, useGetTruckEvents, useGetTruckEventsOverview } from "@/machines/api/queries/events.queries.ts";
import { QUERY_KEYS } from "@/machines/api/config.ts";
import { useGetMachineById } from "@/machines/api/queries/machines.queries.ts";
import { useDateTimeRangeStore } from "@/shared/stores/useDateTimeRangeStore.ts";

const MachinesDetail = () => {
  const { id } = useParams();
  const { getFilters } = useFilterStore();
  const filters = getFilters(QUERY_KEYS.MACHINES);

  const { value } = useDateTimeRangeStore();

  const { data: machine, status } = useGetMachineById(id);

  // Both feed the TimelineProvider below, which draws a time range — a window
  // that stops at the first page is a hole in that range, not a second page.
  const { data: events, status: eventsStatus } = useGetEvents({
    device_mxid: machine?.data?.device_mxid,
    start_time: value.fromDate,
    end_time: value.toDate,
    page: 1,
    itemsPerPage: 20000,
  }, { fetchAll: true });

  const { data: truckEvents, status: truckEventsStatus } = useGetTruckEvents({
    device_mxid: machine?.data?.device_mxid,
    start_time: value.fromDate,
    end_time: value.toDate,
    page: 1,
    itemsPerPage: 1000,
  }, { fetchAll: true });

  const { data: truckEventsOverview } = useGetTruckEventsOverview({
    device_mxid: machine?.data?.device_mxid,
    start_time: value.fromDate,
    end_time: value.toDate,
  });

  const isTimelineLoading = status !== "success" || eventsStatus === "pending" || truckEventsStatus === "pending";
  const isTimelineEmpty = !isTimelineLoading &&
    Array.isArray(events?.data) && events.data.length === 0 &&
    Array.isArray(truckEvents?.data) && truckEvents.data.length === 0;

  return (
    <TimelineProvider events={events?.data} truckEvents={truckEvents?.data}>
      <MachinesDetailContent
        machine={machine}
        status={status}
        isTimelineLoading={isTimelineLoading}
        isTimelineEmpty={isTimelineEmpty}
        truckEventsOverview={truckEventsOverview}
      />
    </TimelineProvider>
  );
}

export default MachinesDetail;